import { createActions } from 'redux-actions';

import types from 'state/salesIntelligence/actionTypes';

const { salesIntelligence } = createActions({
  [types.dismissRecurringOrderSuggestion$]: ({ sendEvent, reason }) => ({
    sendEvent,
    reason,
  }),
  [types.acceptRecurringOrderSuggestion$]: () => ({}),
  [types.fetchForRecurringOrderSuggestion$]: (params) => ({ ...params }),
  [types.openRecurringOrderSuggestionsModal$]: () => ({}),
  [types.closeRecurringOrderSuggestionsModal$]: () => ({}),
  [types.openRecurringOrderSuggestionsDiscardReasonsModal$]: () => ({}),
  [types.closeRecurringOrderSuggestionsDiscardReasonsModal$]: () => ({}),
  [types.SET_RECURRING_ORDER_SUGGESTION]: (suggestion) => ({ suggestion }),
});

export default salesIntelligence;
